import Immutable from 'seamless-immutable';
import _ from 'lodash';

// Удаляет элемены объекта по маске ключа
export const dropElByKeyMaskFromObj = (obj, mask, includes = false) => {
  const newObj = { ...obj };
  Object.keys(newObj).map(key => {
    if ((includes && key.includes(mask)) || key === mask) {
      delete newObj[key];
    }
    return null;
  });
  return newObj;
};

export const dropElByIdxFromArr = (arr, key) => {
  const newArr = Immutable.asMutable(arr);
  _.pullAt(newArr, [key]);
  return newArr;
};



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/imutableHalpers.js